import React from "react";

export default function PackageIcon() {
  return (
    <svg
      className="fire-explosion__pkg-icon-svg"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M8 14h32v22a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V14z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M16 14V10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v4"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M24 22l-6 10h12L24 22z"
        fill="currentColor"
        opacity="0.25"
      />
      <path
        d="M24 20l-7 12h14L24 20z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
}
